import { Image, Link, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import Button from '../Shared/components/controls/Button';
import './style.scss';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
import { withTranslation } from 'react-i18next';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const DownloadFABComponent = (props) => {
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="DownloadFABComponent" />;
  }
  const { fields, params } = props;

  const { logo, image, items, subheading, heading, description, link, text, qrcode } = fields;
  const shouldRenderLogo = logo?.value?.src;
  const shouldRenderSubHeading = subheading?.value;
  const shouldRenderHeading = heading?.value;
  const shouldRenderText = text?.value;
  const shouldRenderQrCode = qrcode?.value?.src;
  const shouldRenderImage = image?.value?.src;
  const shouldRenderDescription = description?.value;
  const shouldRenderLink = link?.value?.href;

  const { t: translate } = props;
  const txt_back = translate('Back');

  const BackButton = ({ cssClass, srcImage }) => {
    const menuStyle = clsx({
      ['back-button']: true,
      [cssClass]: cssClass !== '',
    });
    const history = useHistory();

    function handleClick() {
      history.goBack();
    }
    return (
      //https://www.codegrepper.com/code-examples/javascript/usehistory+go+back
      <div className="buttonWrap">
        <button className={menuStyle} onClick={handleClick}>
          {srcImage && (
            <span className="image">
              <img src={srcImage} />
            </span>
          )}
          <div className="label">{txt_back}</div>
        </button>
      </div>
    );
  };

  return (
    <div className={clsx('fab-download-section', 'add-margins', params?.Styles)}>
      <div className="wrap content">
        <div className="head">
          <a href="" className="logo">
            {shouldRenderLogo && <Image field={logo} />}
          </a>
        </div>

        <BackButton
          cssClass="addMarginBottom"
          srcImage={`/-/jssmedia/Project/FAB2/shared/images/backArrowWhite.svg`}
        />

        <div className="content-block">
          {shouldRenderSubHeading && (
            <div className="title">
              <Text field={subheading} />
            </div>
          )}
          {shouldRenderHeading && (
            <div className="subtitle">
              <Text field={heading} />
            </div>
          )}
          {shouldRenderText && (
            <div className="description">
              <RichText field={text} />
            </div>
          )}
          <div className="images-app">
            <div className="small-images flex-inline flex-wrap flex-align-item-end">
              {items &&
                items.map((item, i) => {
                  const fieldLink = item?.fields?.link;
                  const shouldRender = fieldLink?.value;
                  return (
                    shouldRender && (
                      <div key={i} className="image-item">
                        <Link field={fieldLink} className="csp-card">
                          {item?.fields?.image && <Image field={item?.fields?.image} />}
                        </Link>
                      </div>
                    )
                  );
                })}
              {shouldRenderQrCode && (
                <div className="image-item qrCode">
                  <Image field={qrcode} />
                </div>
              )}
            </div>
            <div className="big-image flex-inline">
              {shouldRenderImage && <Image field={image} />}
            </div>
          </div>
        </div>
        <div className="bottom-content">
          <div className="wrap-bottom-content">
            <div className="group flex-it flex-align-item-center">
              {shouldRenderDescription && <RichText className="text" field={description} />}
              {shouldRenderLink && <Button variant="contained" link={link} color="secondary" />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(DownloadFABComponent);
